<template>
  <div style="max-width: 350px;" class="ml-auto xfloat-right" xclass="mt-auto mb-auto text-muted">
    <VueTypeaheadBootstrap
      placeholder="Account manager on behalf of..." 
      v-bind="$attrs"
      v-model="inputText"
      :data="users"
      :serializer="serializer"
      :input-class="isValidClass()"
      @hit="hit"
      @input="search"
      class="p-0 m-0"
    />
  </div>
</template>

<script>
import VueTypeaheadBootstrap from '@/views/components/VueTypeaheadBootstrap'
import userAPI from '@/api/user'

export default {
  name: 'AdminBar',
  components: {
    VueTypeaheadBootstrap
  },
  data () {
    return {
      inputText: '',
      users: [],
      abortController: null,
    }
  },
  computed: {
    selectedUser () {
      return this.$store.state.organisation.onBehalfOfUser
    }
  },
  watch: {
    async 'inputText' (newValue) {
      if (!this.selectedUser) {return}
      if (newValue !== this.serializer(this.selectedUser)) {
        await this.$store.dispatch('organisation/setOnBehalfOfUser', null)
      }
    },
    '$store.state.organisation.onBehalfOfUser' (newValue) {
      if (newValue) {
        this.inputText = this.serializer(newValue)
      }
    }
  },
  methods: {
    isValidClass (value) {
      return Boolean(this.selectedUser) ? 'notick-is-valid' : ''
    },
    async search () {
      try {
        if (this.abortController) {
          this.abortController.abort()
        }
        this.abortController = new AbortController()
        const result = await userAPI.getList(100, 1, this.inputText, this.abortController.signal)
        this.users = result.data
      } catch (e) {
        if (e.code !== 'ERR_CANCELED') {
          console.error(e)
        }
      }
    },
    async hit (user) {
      console.log('AdminBar hit', user)
      await this.$store.dispatch('organisation/setOnBehalfOfUser', user)
    },
    serializer (item) {
      return item.fullName + ' (' + item.email + ')'
    },
  }
}
</script>

<style>
.vbt-autcomplete-list {
  padding-top: 0 !important;
  background-color: white !important;  
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
  height: 18px;
  width: 18px;
  margin-left: .2em;
  margin-top: .1em;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23777'><path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/></svg>");
  cursor: pointer;
}

.notick-is-valid {
  border-color: #321fdb !important;
}

.notick-is-valid:focus {
  border-color: #321fdb;
  -webkit-box-shadow: 0 0 0 0.2rem rgb(50 31 219 / 25%) !important;
  box-shadow: 0 0 0 0.2rem rgb(50 31 219 / 25%) !important;
}
</style>